import React, { useContext, VFC } from "react";
import { Tabs } from "antd";
import { NotificationsContainer } from ".";
import { NotificationSubscriptionContext } from "../../components/subscriptions/notification-subscription-provider";
import { useLocation } from "react-router";
import { NotificationType } from "../../graphql/types";

export const NotificationWrapper: VFC = () => {
  const location = useLocation();
  const locationState = location.state as { notificationType: NotificationType };
  const {
    notificationContext: { nextNotificationType },
  } = useContext(NotificationSubscriptionContext);
  const activeKey = locationState?.notificationType || nextNotificationType;

  const items = [
    {
      label: "Notifications",
      key: "Standard",
      children: <NotificationsContainer type={NotificationType.Standard} />,
    },
    {
      label: "Alerts",
      key: "Alert",
      children: <NotificationsContainer type={NotificationType.Alert} />,
    },
  ];

  return (
    <>
      <Tabs items={items} defaultActiveKey={activeKey || "Alert"} type="card" size="small" />
    </>
  );
};
